/** @jsx jsx */
import { jsx } from '@emotion/react';
import { loadingStyles } from './loadingStyles';
import { Intent, Spinner } from '@blueprintjs/core';

const LoadingIcon = ({ size = 32, className = '' }) => {
	return (
		<div cy-test="spinner-load" className={className} css={loadingStyles.loadingIconContainer}>
			<Spinner intent={Intent.PRIMARY} size={size} />
		</div>
	);
};

export default LoadingIcon;
